import { Outlet } from 'react-router-dom';

const PrintLayout = () => {
	return (
		<div className='flex flex-col min-h-screen'>
			<div className='flex flex-1'>
				<div className='flex flex-col flex-1'>
					<Outlet />
				</div>
			</div>
		</div>
	);
};

export default PrintLayout;
